export const SNACKBAR_TIMEOUT = 2000
export const SNACKBAR_TIMEOUT_TO_AUTOSAVE = 2000
export const SNACKBAR_DEFAULT_POSITION = 'top right'
export const SNACKBAR_SUCCESS_ICON = 'mdi-check'
export const SNACKBAR_ERROR_ICON = 'mdi-alert-circle'
export const SNACKBAR_WARNING_ICON = 'mdi-alert'
export const SNACKBAR_INFO_ICON = 'mdi-information-outline'
